import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

const CouponDownloadModal: ActivityComponentType = () => {
  const { pop } = useFlow();
  return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={32}>
                    <Column spacing={8} align='center' fullWidth>
                        <Text size='4xl' fontWeight='bold' align='center'>
                            쿠폰 다운을 완료했습니다.
                        </Text>
                        <Text align='center' size='xl'>
                            받은 쿠폰은 ‘MY 쿠폰’ 에서 확인 하실 수 있습니다.
                        </Text>
                    </Column>
                    <Button fullWidth onClick={pop}>
                        확인
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default CouponDownloadModal;
